import { EViewSolarEstimationSolarProductCategory } from "../enums/view-solar-estimation-solar-product-category";

export const getSolarProductIcon = (
  category: EViewSolarEstimationSolarProductCategory
) => {
  switch (category) {
    case EViewSolarEstimationSolarProductCategory.INVERTERS:
      return "tablet_mac";
    case EViewSolarEstimationSolarProductCategory.BATTERIES:
      return "battery_horiz_000";
    case EViewSolarEstimationSolarProductCategory.PANELS:
      return "solar_power";
    case EViewSolarEstimationSolarProductCategory.WATER_HEATER_CONTROLLERS:
      return "google_tv_remote";
    case EViewSolarEstimationSolarProductCategory.WATER_HEATERS:
      return "propane";
    default:
      return "tune";
  }
};
